/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import { useTranslation } from 'react-i18next';
import useBreakpoint from '../../../../hooks/breakpoint';
import classes from './InnerDocumentText.module.scss';

export default function InnerDocumentText({ delay, className }) {
  const { t } = useTranslation();
  const { large } = useBreakpoint();

  return (
    <div className={classes.textContainer}>
      {large && (
        <>
          <h5 id="text-document-container">{t('documentation.addFiles.title')}</h5>
          <p style={{ color: '#838aa2' }} id="text-document-container-p">
            o{' '}
            <a id="text-document-container-link" href="#">
              {t('documentation.addFiles.titleLink')}
            </a>
          </p>
        </>
      )}
      {!large && <a>{t('documentation.addFiles.titleResponsive')}</a>}
      <p className={classes.filesAllowed}>{t('documentation.addFiles.subTitle')}</p>
      {/* delay ? <h6 className="aclaracion">Puedes subirlos más tarde</h6> : "" */}
    </div>
  );
}
